import React from 'react';
import { Link } from 'react-router-dom';

import { datamodelTypeLookup } from '@constants';

import './DataModel.scss';

export const DataModel = ({ businessID, datamodel }) => {
  return (
    <div className="sb-row-item">
      <div className="sb-row--datamodel-name">
        <p>
          <b>
            <Link
              to={`/dashboard/projects/${businessID}/datamodels/${datamodel.id}`}
            >
              {datamodel.name}
            </Link>
          </b>
        </p>
      </div>
      <div className="sb-row--datamodel-type">
        <p>{datamodelTypeLookup[datamodel.datamodel_type]}</p>
      </div>
      <div className="sb-row--datamodel-id">
        <p>ID: {datamodel.id}</p>
      </div>
    </div>
  );
};
